import { useMemo } from 'react';
import { Schedule } from '../../types';
import { type UseScheduleActivationReturn } from '../activation/hooks/useScheduleActivation';
import { type UseScheduleManagementReturn } from '../management/hooks/useScheduleManagement';

export interface ScheduleControls {
  pause: (scheduleId: number) => void;
  activate: (schedule: Schedule) => void;
  reactivate: (schedule: Schedule) => void;
  configure: (schedule: Schedule) => void;
  viewActivities: (schedule: Schedule) => void;
}

export function useScheduleControls(
  activation: Pick<UseScheduleActivationReturn, 'startActivation'>,
  management: Pick<UseScheduleManagementReturn, 'requestPause' | 'openConfigModal' | 'openActivitiesModal'>
): ScheduleControls {
  return useMemo<ScheduleControls>(
    () => ({
      pause: management.requestPause,
      activate: (schedule: Schedule) => activation.startActivation(schedule, 'activate'),
      reactivate: (schedule: Schedule) => activation.startActivation(schedule, 'reactivate'),
      configure: management.openConfigModal,
      viewActivities: management.openActivitiesModal,
    }),
    [activation, management]
  );
}
